import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the usersDetail state domain
 */

const selectUsersDetailDomain = state => state.usersDetail || initialState;

/**
 * Other specific selectors
 */


const makeSelectLoading = () =>
  createSelector(
    selectUsersDetailDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectUsersDetailDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectUsersDetailDomain,
    substate => substate.id,
  );
  
const makeSelectFirstRender = () =>
  createSelector(
    selectUsersDetailDomain,
    substate => substate.firstRender,
  );

const makeSelectUser = () =>
  createSelector(
    selectUsersDetailDomain,
    substate => substate.userData,
    );
  
/**
 * Default selector used by UsersDetail
 */

const makeSelectUsersDetail = () =>
  createSelector(
    selectUsersDetailDomain,
    substate => substate,
  );

export default makeSelectUsersDetail;
export {
  selectUsersDetailDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectUser
};
